export default function HomePage() {
  return (
    <div className="container">
      <h1>Welcome to Candly</h1>
      <p>Create a profile and light up virtual candles ✨</p>
    </div>
  );
}
